import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import Chat from "../../../components/Chat";

function EducationCustomerSupport() {
  return (
    <NavigationDrawer>
      <Chat />
    </NavigationDrawer>
  );
}

export default EducationCustomerSupport;
